const allowedReturnPaths = new Set(['/account', '/admin/intakes', '/admin/intakes/new'])

/** Return paths are an allowlist, never a general URL parser. */
export function safeReturnPath(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined
  const [path = '', query = ''] = value.split('?', 2)
  if (!allowedReturnPaths.has(path) || path.includes('\\') || query.includes('\\')) return undefined
  return query ? `${path}?${query}` : path
}
